module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/mountains.59ae5de7b43ed13fb0ebafba9be4eb7f.jpg";